import { render, staticRenderFns } from "./LiveDataMoney.vue?vue&type=template&id=bf575598&scoped=true"
import script from "./LiveDataMoney.vue?vue&type=script&lang=js"
export * from "./LiveDataMoney.vue?vue&type=script&lang=js"
import style0 from "./LiveDataMoney.vue?vue&type=style&index=0&id=bf575598&prod&scoped=true&lang=css"
import style1 from "./LiveDataMoney.vue?vue&type=style&index=1&id=bf575598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf575598",
  null
  
)

export default component.exports